import React from 'react';
import { TablePagination as MuiTablePagination, IconButton } from '@material-ui/core';
import { ArrowsContainer, PaginationLabel, Div } from '../../../Common/Table/styles';
import { ArrowRight, ArrowLeft } from 'src/assets/Images';
function TablePaginationActions(props) {
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onPageChange = props.onPageChange;
    var handleBackButtonClick = function (event) { return onPageChange(event, page - 1); };
    var handleNextButtonClick = function (event) { return onPageChange(event, page + 1); };
    return (React.createElement(Div, { className: "centered" },
        React.createElement(ArrowsContainer, null,
            React.createElement(IconButton, { onClick: handleBackButtonClick, disabled: !page, "aria-label": "previous page" },
                React.createElement("img", { src: ArrowLeft, alt: "P\u00E1gina previa" })),
            React.createElement(PaginationLabel, null, page + 1 + "/" + Math.ceil(count / rowsPerPage)),
            React.createElement(IconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page" },
                React.createElement("img", { src: ArrowRight, alt: "P\u00E1gina siguiente" })))));
}
export var TablePagination = function (_a) {
    var count = _a.count, page = _a.page, rowsPerPage = _a.rowsPerPage, onPageChange = _a.onPageChange;
    return (React.createElement(MuiTablePagination, { component: "div", labelRowsPerPage: "", count: count, rowsPerPage: rowsPerPage, page: page, onPageChange: onPageChange, ActionsComponent: TablePaginationActions }));
};
